import { render, staticRenderFns } from "./slideshowList.vue?vue&type=template&id=f256f52a&scoped=true&"
import script from "./slideshowList.vue?vue&type=script&lang=js&"
export * from "./slideshowList.vue?vue&type=script&lang=js&"
import style0 from "./slideshowList.vue?vue&type=style&index=0&id=f256f52a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f256f52a",
  null
  
)

export default component.exports